var $lockMZUpdate = false,
    $firstImageIsVideo = false;
mzOptions = mzOptions || {};
mzOptions.onUpdate = function() {
    if (!$lockMZUpdate) {
        mtHighlightActiveSelector();
        videoSlideUpdate();
    }
    $lockMZUpdate = false;
};
var mtZoomIsReady = false;
mzOptions.onZoomReady = function(id) {
   // videoSlideUpdateForGallery();
    mtZoomIsReady = true;
    if (!$firstImageIsVideo) {
        mtHighlightActiveSelector();
    }
}
function mtIfZoomReady(fnc) {
    if (!mtZoomIsReady) {
        setTimeout(function() {
            mtIfZoomReady(fnc);
        }, 250);
        return;
    }
    fnc();
}
mzOptions.onExpandClose = function(zoom_id) {
  window._kalkiPopupVideoActive = false;
  window._kalkiPopupVideoUrl = null;
  if(window._kalkiStageObserver) { window._kalkiStageObserver.disconnect(); window._kalkiStageObserver = null; }
  // Remove video-slide classes from popup thumbs
  document.querySelectorAll('.mz-expand .magic-thumb').forEach(function(t) {
    t.classList.remove('video-slide', 'video-slide-1', 'video-slide-2', 'magic-thumb-selected');
  });
  // Clean zoom slide — remove video player and hide-image
  var zs = document.querySelector('.MagicToolboxContainer .MagicToolboxSlides .MagicToolboxSlide[data-slide-id="zoom"]');
  if(zs) {
    zs.classList.remove('hide-image');
    zs.querySelectorAll('.custom-video-player').forEach(function(v){
      var ifrm = v.querySelector('iframe'); if(ifrm) ifrm.src = ''; v.remove();
    });
    zs.querySelectorAll('img').forEach(function(i){
      i.style.visibility = ''; i.style.opacity = ''; i.style.display = '';
    });
  }
  // Hard reset MagicZoom — always, not just bridal
  $lockMZUpdate = true;
  MagicZoom.refresh(zoom_id);
}
// ============================================================
// POPUP VIDEO HANDLING - Clean simple approach
// ============================================================
// Core function: inject video into popup figure
function _kalkiShowPopupVideo(videoUrl) {
  var fig = document.querySelector('.mz-expand .mz-image-stage figure.mz-figure')
    || document.querySelector('.mz-expand .mz-image-stage figure')
    || document.querySelector('.mz-expand .mz-image-stage');
  if(!fig || !videoUrl) return false;
  // Idempotent (July 2026): same video already active -> do nothing. This is
  // what makes it safe to call from onExpandUpdate without re-injection races.
  if(window._kalkiPopupVideoActive && window._kalkiPopupVideoUrl === videoUrl
     && fig.querySelector('.kalki-popup-player')) {
    return true;
  }
  fig.style.position = 'relative';
  // Remove old player
  var old = fig.querySelector('.kalki-popup-player');
  if(old) old.remove();
  // Hide background image
  var bgImg = fig.querySelector('img');
  if(bgImg) bgImg.style.visibility = 'hidden';
  // Inject player
  var player = document.createElement('div');
  player.className = 'kalki-popup-player';
  player.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;z-index:99;background:#000;';
  var iframe = document.createElement('iframe');
  iframe.src = videoUrl;
  iframe.style.cssText = 'width:100%;height:100%;border:0;';
  iframe.setAttribute('allow', 'autoplay; fullscreen');
  iframe.setAttribute('allowfullscreen', '');
  player.appendChild(iframe);
  fig.appendChild(player);
  window._kalkiPopupVideoActive = true;
  window._kalkiPopupVideoUrl = videoUrl;
  return true;
}
function _kalkiHidePopupVideo() {
  window._kalkiPopupVideoActive = false;
  window._kalkiPopupVideoUrl = null;
  var fig = document.querySelector('.mz-expand .mz-image-stage figure.mz-figure')
    || document.querySelector('.mz-expand .mz-image-stage figure')
    || document.querySelector('.mz-expand .mz-image-stage');
  if(!fig) return;
  var old = fig.querySelector('.kalki-popup-player');
  if(old) {
    var ifrm = old.querySelector('iframe');
    if(ifrm) ifrm.src = '';
    old.style.display = 'none';
    old.remove();
  }
  var bgImg = fig.querySelector('img');
  if(bgImg) bgImg.style.visibility = '';
}
// _kalkiWatchAndRestore disabled — causes re-injection race conditions
function _kalkiWatchAndRestore() {}
// Sync popup video with the currently selected popup thumb (July 2026).
// Show when a video thumb is selected, hide otherwise. Safe to call
// repeatedly: _kalkiShowPopupVideo is idempotent (same URL -> no-op) and
// hiding when nothing is active is a no-op too — so no re-injection races.
function _kalkiSyncPopupVideo() {
  var exp = document.querySelector('.mz-expand');
  if(!exp) return;
  var sel = exp.querySelector('.magic-thumb.magic-thumb-selected');
  if(!sel) {
    // No detectable selection (class scheme changed / mid-transition):
    // never leave a stuck video over an unknown image.
    if(window._kalkiPopupVideoActive) _kalkiHidePopupVideo();
    return;
  }
  var isV1 = sel.classList.contains('video-slide-1');
  var isV2 = sel.classList.contains('video-slide-2');
  if(isV1 || isV2) {
    var orig = isV2 ? document.querySelector('[js-custom-video-slide-2]')
                    : document.querySelector('[js-custom-video-slide]');
    var url = orig ? (orig.getAttribute('data-video-url')
                   || orig.getAttribute('data-video-url-desktop')
                   || orig.getAttribute('data-video-url-large')) : '';
    if(url) _kalkiShowPopupVideo(url);
  } else {
    if(window._kalkiPopupVideoActive) {
      _kalkiHidePopupVideo();
      // Our video thumbs get magic-thumb-selected added manually on click;
      // arrows select a new thumb via MagicZoom without clearing ours.
      exp.querySelectorAll('.magic-thumb.video-slide').forEach(function(t) {
        t.classList.remove('magic-thumb-selected');
      });
    }
  }
}
// onExpandUpdate fires after MagicZoom switches the popup image — this is
// the ONLY hook that covers ARROW and SWIPE navigation (no thumb click
// involved), which previously left the video iframe stuck over every
// subsequent image. Slight delay lets MagicZoom finish updating the
// selected-thumb class before we read it.
mzOptions.onExpandUpdate = function() {
  setTimeout(_kalkiSyncPopupVideo, 60);
};
mzOptions.onExpandOpen = function() {
  window._kalkiPopupVideoActive = false;
  window._kalkiPopupVideoUrl = null;
  setTimeout(function() {
    // Detect VIDEO1 and VIDEO2 thumbs in popup
    var v1img = document.querySelector('.mz-expand .magic-thumb img[alt="custom video"]');
    var v2img = document.querySelector('.mz-expand .magic-thumb img[alt="custom video 2"]');
    // VIDEO1 fallback: match by filename
    if(!v1img) {
      var origV1 = document.querySelector('[js-custom-video-slide]');
      if(origV1) {
        var v1File = (origV1.getAttribute('href') || '').split('/').pop().split('?')[0].split('.')[0];
        document.querySelectorAll('.mz-expand .magic-thumb img').forEach(function(img) {
          var li = img.closest('.magic-thumb');
          if(!li || li.classList.contains('video-slide-2')) return;
          var srcFile = (img.getAttribute('src') || '').split('/').pop().split('?')[0].split('.')[0];
          if(srcFile && v1File && srcFile === v1File) v1img = img;
        });
      }
    }
    if(v1img) v1img.closest('.magic-thumb').classList.add('video-slide', 'video-slide-1');
    if(v2img) v2img.closest('.magic-thumb').classList.add('video-slide', 'video-slide-2');
    // Reorder popup thumbnails: move video-slide-1 to 3rd position, video-slide-2 to 4th
    var thumbList = document.querySelector('.mz-expand .mz-expand-thumbnails ul')
      || document.querySelector('.mz-expand .magic-thumbs ul')
      || document.querySelector('.mz-expand ul');
    if(thumbList && v1img) {
      var v1li = v1img.closest('.magic-thumb');
      var v2li = v2img ? v2img.closest('.magic-thumb') : null;
      var items = Array.from(thumbList.children);
      // Find 3rd item (index 2)
      var thirdItem = items[2];
      if(thirdItem && v1li && v1li !== thirdItem) {
        thumbList.insertBefore(v1li, thirdItem);
      }
      // VIDEO2 goes right after VIDEO1 (now at index 2, so insert at index 3)
      if(v2li && v1li) {
        thumbList.insertBefore(v2li, v1li.nextSibling);
      }
    }
    // Bind click + touch handlers for both desktop and mobile
    function _kalkiVideoThumbHandler(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var li = e.currentTarget;
      var isV2 = li.classList.contains('video-slide-2');
      var origSlide = isV2
        ? document.querySelector('[js-custom-video-slide-2]')
        : document.querySelector('[js-custom-video-slide]');
      var videoUrl = origSlide ? (origSlide.getAttribute('data-video-url') || origSlide.getAttribute('data-video-url-desktop') || origSlide.getAttribute('data-video-url-large')) : '';
      if(!videoUrl) return;
      document.querySelectorAll('.mz-expand .magic-thumb').forEach(function(t) { t.classList.remove('magic-thumb-selected'); });
      li.classList.add('magic-thumb-selected');
      _kalkiShowPopupVideo(videoUrl);
    }
    document.querySelectorAll('.mz-expand .magic-thumb.video-slide').forEach(function(li) {
      li.style.cursor = 'pointer';
      li.addEventListener('click',      _kalkiVideoThumbHandler, true);
      li.addEventListener('touchend',   _kalkiVideoThumbHandler, true);
      li.addEventListener('touchstart', function(e){ e.stopImmediatePropagation(); }, true);
    });
    // Remove video when non-video thumb clicked/touched
    document.querySelectorAll('.mz-expand .magic-thumb:not(.video-slide)').forEach(function(li) {
      function _kalkiHideHandler(e) {
        if(window._kalkiStageObserver) { window._kalkiStageObserver.disconnect(); window._kalkiStageObserver = null; }
        // Remove magic-thumb-selected from ALL thumbs so video thumb doesn't stay highlighted
        document.querySelectorAll('.mz-expand .magic-thumb').forEach(function(t) {
          t.classList.remove('magic-thumb-selected');
        });
        _kalkiHidePopupVideo();
      }
      // touchstart — hide immediately on first touch, before MagicZoom fires
      li.addEventListener('touchstart', _kalkiHideHandler, true);
      li.addEventListener('click',      _kalkiHideHandler, true);
    });
  }, 400);
};
function videoSlideUpdate() {
  // Popup open? Delegate to the shared sync (handles show AND hide by
  // selected thumb). NOTE (July 2026): this must run BEFORE the
  // _kalkiPopupVideoActive early-return below — the old order blocked the
  // hide path entirely, so once a popup video played, arrow/swipe
  // navigation left it stuck over every following image. Also matches any
  // .mz-expand (the old .blurred-only check silently skipped some open
  // states).
  if(document.querySelector('.mz-expand')) {
    _kalkiSyncPopupVideo();
    return; // popup is open — don't run normal view logic
  }
  //============ For main image swipe
  // Skip main-view logic while (somehow) flagged active without a popup
  if(window._kalkiPopupVideoActive) {
 return; }
  if(document.querySelector('.product-custom.bridal-pdp') == null || window.screen.width < 750 ) {
    let activeThumbSlide = document.querySelector('.MagicToolboxContainer .MagicToolboxSelectorsContainer a.mz-thumb-selected');
    // Swipe fallback
    if(!activeThumbSlide) activeThumbSlide = document.querySelector('.MagicToolboxContainer .MagicToolboxSelectorsContainer a.active-magic-selector');
    // Swipe fallback 2: detect from active slide
    if(!activeThumbSlide || !activeThumbSlide.classList.contains('video-slide')) {
      var activeSlide = document.querySelector('.MagicToolboxContainer .MagicToolboxSlide.active-magic-slide');
      if(activeSlide) {
        var sid = activeSlide.getAttribute('data-slide-id');
        if(sid === 'video-1') activeThumbSlide = document.querySelector('[js-custom-video-slide]');
        else if(sid === 'video-gumlet2') activeThumbSlide = document.querySelector('[js-custom-video-slide-2]');
      }
    }
    // Always use the zoom slide (first slide) as the container for custom-video-player
    // This is the slide with mz-figure where we inject the iframe
    let zoomSlide = document.querySelector('.MagicToolboxContainer .MagicToolboxSlides .MagicToolboxSlide[data-slide-id="zoom"]');
    if(activeThumbSlide && activeThumbSlide.classList.contains('video-slide')) {
      var videoUrl = activeThumbSlide.getAttribute('data-video-url') 
              || activeThumbSlide.getAttribute('data-video-url-large')
              || activeThumbSlide.getAttribute('data-video-url-desktop');
      // For both VIDEO1 and VIDEO2: inject into zoom slide's mz-figure
      // Make zoom slide active and hide image so video shows
      document.querySelectorAll('.MagicToolboxContainer .MagicToolboxSlide').forEach(function(s){ s.classList.remove('active-magic-slide'); });
      zoomSlide.classList.add('active-magic-slide');
      zoomSlide.classList.add('hide-image');
      // Remove old player and inject new
      zoomSlide.querySelectorAll('.custom-video-player').forEach(function(v){ v.remove(); });
      var fig = zoomSlide.querySelector('figure.mz-figure');
      if(fig) {
        var label = activeThumbSlide.hasAttribute('js-custom-video-slide-2') || activeThumbSlide.getAttribute('data-kalki-video-2')
          ? 'add video 2 (gumlet_video_urls)' : 'add video';
        var iframeHtml = '<div class="custom-video-player"><iframe width="640" height="360" src="' + videoUrl + '" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" referrerpolicy="origin" allow="autoplay"></iframe></div>';
        fig.insertAdjacentHTML('beforeend', iframeHtml);
      }
    } else {
      // Not a video — remove player and let MagicZoom handle the image via its own click handler
      if(zoomSlide) {
        zoomSlide.classList.remove('hide-image');
        zoomSlide.querySelectorAll('.custom-video-player').forEach(function(v){
          var ifrm = v.querySelector('iframe');
          if(ifrm) ifrm.src = '';
          v.remove();
        });
      }
      // Use MagicZoom.switchTo to show correct image without triggering video logic
      if(activeThumbSlide) {
        var mzPlusEl = document.querySelector('a.MagicZoomPlus');
        if(mzPlusEl) {
          $lockMZUpdate = true;
          MagicZoom.switchTo(mzPlusEl.id, activeThumbSlide);
        }
      }
    }
    
  }
  
   //============ For popup gallary swipe
   let activeThumbSlideGallery = document.querySelector('.mz-expand .magic-thumb.magic-thumb-selected img');
   if(activeThumbSlideGallery) {
              let imageAlt = activeThumbSlideGallery.getAttribute('alt');
              if(imageAlt && (imageAlt.includes('custom video') || imageAlt.includes('custom video 2'))) {
                    let videoUrl = '';
                    // Pick correct video source based on which thumbnail is active
                    if(imageAlt.includes('custom video 2')) {
                      let customVideoSlide2 = document.querySelector('[js-custom-video-slide-2]');
                      if(customVideoSlide2) {
                        videoUrl = customVideoSlide2.getAttribute('data-video-url');
                      }
                    } else {
                      let customVideoSlide = document.querySelector('[js-custom-video-slide]');
                      if(customVideoSlide) {
                        videoUrl = customVideoSlide.getAttribute('data-video-url');
                      }
                    }
                  let galleryMaincontainer = document.querySelector('.mz-expand .mz-image-stage figure.mz-figure');
                  galleryMaincontainer.classList.add('hide-gallery-image');
                  // Always replace player so switching between v1/v2 works
                  var oldPlayer = galleryMaincontainer.querySelector('.custom-video-player');
                  if(oldPlayer) oldPlayer.remove();
                  if(videoUrl) {
                    let iframeHtml = '<div class="custom-video-player"><iframe width="640" height="360" src="' + videoUrl + '" allow="autoplay; fullscreen" webkitallowfullscreen mozallowfullscreen allowfullscreen referrerpolicy="origin"></iframe></div>';
                    galleryMaincontainer.insertAdjacentHTML('beforeend', iframeHtml);
                  }
             }
              else {
                  let galleryMaincontainer = document.querySelector('.mz-expand .mz-image-stage figure.mz-figure');
                  galleryMaincontainer.classList.remove('hide-gallery-image');
                  if(galleryMaincontainer.querySelector('.custom-video-player')) {
                    galleryMaincontainer.querySelector('.custom-video-player').remove();
                  }
             }
          }
}
function mtInitSelectors(selector) {
    jQuery(selector).on((mzOptions && mzOptions.selectorTrigger && mzOptions.selectorTrigger == 'hover') ? 'mouseover click touchend' : 'click touchend', function(e) {
       
var el = jQuery(this);
        // Stop current slide iframe by blanking src
        var $prevIframe = jQuery('.active-magic-slide iframe.product-main-video');
        if ($prevIframe.length) {
            $prevIframe.attr('src', '');
        }
        var $video = jQuery('.active-magic-slide video');
        if ($video.length == 1) {
            $video.get(0).pause();
        }
        jQuery('.MagicToolboxContainer .MagicToolboxSlide').removeClass('active-magic-slide');
        // If this is the VIDEO2 thumb (data-kalki-video-2), activate video-gumlet2 slide
        var targetSlideId = el.attr('data-kalki-video-2') ? 'video-gumlet2' : el.attr('data-slide-id');
        jQuery('.MagicToolboxContainer .MagicToolboxSlide[data-slide-id="' + targetSlideId + '"]').addClass('active-magic-slide');
        jQuery('.MagicToolboxContainer .MagicToolboxSelectorsContainer a').removeClass('active-magic-selector mz-thumb-selected');
        el.addClass('active-magic-selector mz-thumb-selected');
        if (el.attr('data-slide-id') == 'spin') {
            var resizeEvent = window.document.createEvent('UIEvents');
            resizeEvent.initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(resizeEvent);
            if (typeof jQuery('.Sirv').attr('data-started') == 'undefined') {
                Sirv.start();
                jQuery('.Sirv').attr('data-started', 1)
            }
        }
        // Lazy-load the newly active slide iframe using correct size src
        // data-src-* already contains full URL with all params — do NOT append data-video-options
        var $newIframe = jQuery('.active-magic-slide iframe.product-main-video');
        if ($newIframe.length) {
            var _w = window.innerWidth;
            var _size = _w <= 749 ? 'mobile' : _w >= 1921 ? 'large' : 'desktop';
            var _src = $newIframe.attr('data-src-' + _size) || $newIframe.attr('data-src-desktop');
            if (_src) {
                $newIframe.attr('src', _src);
            }
        }
        var $video = jQuery('.active-magic-slide video');
        if ($video.length == 1) {
            $video.get(0).play();
        }
        // For video-gumlet2 and js-custom-video-slide slides, mzOptions.onUpdate
        // never fires because MagicZoom does not know these slide types.
        // Call videoSlideUpdate() directly here so the video player renders.
        if (el.is('[js-custom-video-slide]') || el.is('[js-custom-video-slide-2]')) {
            $lockMZUpdate = true; // prevent onUpdate from calling videoSlideUpdate again
            videoSlideUpdate();
        } else {
            // Non-video thumb — clean up video player immediately
            var zs = document.querySelector('.MagicToolboxContainer .MagicToolboxSlides .MagicToolboxSlide[data-slide-id="zoom"]');
            if(zs) {
                zs.classList.remove('hide-image');
                zs.querySelectorAll('.custom-video-player').forEach(function(v){
                    var ifrm = v.querySelector('iframe'); if(ifrm) ifrm.src = ''; v.remove();
                });
            }
        }
        e.preventDefault();
     
    });
}
function mtInitVideoSelectors() {
    jQuery('.MagicToolboxSlides div[data-video-url]').each(function(index) {
        if (jQuery(this).data('processed')) return;
        var regex_youtube_short = /https?:\/\/youtu\.be\/([^\/]{1,})\/?/gm,
            regex_youtube_full = /https?:\/\/www\.youtube\.com\/watch\?v=(.*?)(&|$).*/gm,
        regex_youtube_embed = /https?:\/\/www\.youtube\.com\/(?:embed|shorts)\/(.{1,})/gm,
            regex_vimeo = /https?:\/\/vimeo\.com\/(.{1,})/gm,
            regex_sproutvideo = /https\:\/\/.*?\.vids\.io\/videos\/(.*?)\/.*/gm,
            regex_sproutvideo2 = /https\:\/\/sproutvideo\.com\/videos\/(.*?)\/*$/gm,
            regex_sproutvideo3 = /https:\/\/[a-z]{1,}.sproutvideo\.com\/embed\/(.*?)\/.*?$/gm,
            video_id, video_type;
        var $videoURL = jQuery(this).attr('data-video-url').replace(/https\:\/\/player\.vimeo\.com\/video\/([0-9]{1,})/gm, 'https://vimeo.com/$1');
        var m = regex_youtube_short.exec($videoURL);
        if (m) {
            video_id = m[1];
            video_type = 'youtube';
        } else {
            var m = regex_youtube_full.exec($videoURL);
            if (m) {
                video_id = m[1];
                video_type = 'youtube';
            } else {
                var m = regex_youtube_embed.exec($videoURL);
                if (m) {
                    video_id = m[1];
                    video_type = 'youtube';
                } else {
                    var m = regex_vimeo.exec($videoURL);
                    if (m) {
                        video_id = m[1];
                        video_type = 'vimeo';
                    } else {
                        var m = regex_sproutvideo.exec($videoURL);
                        if (m) {
                            video_id = m[1];
                            video_type = 'sproutvideo';
                        } else {
                            var m = regex_sproutvideo2.exec($videoURL);
                            if (m) {
                                video_id = m[1];
                                video_type = 'sproutvideo';
                            } else {
                                var m = regex_sproutvideo3.exec($videoURL);
                                if (m) {
                                    video_id = m[1];
                                    video_type = 'sproutvideo_embed';
                                }
                            }
                        }
                    }
                }
            }
        }
        if (video_type == 'youtube') {
            jQuery(this).html('<div class="magic-video-container"><iframe src="https://www.youtube.com/embed/' + video_id + '" frameborder="0" allowfullscreen></iframe></div>');
        } else if (video_type == 'vimeo') {
            jQuery(this).html('<div class="magic-video-container"><iframe src="https://player.vimeo.com/video/' + video_id + '" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div>');
        } else if (video_type == 'sproutvideo') {
            jQuery(this).html('<div class="magic-video-container"><iframe src="" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>');
            jQuery.ajax({
                slide_id: jQuery(this).attr('data-slide-id'),
                video_url: $videoURL,
                url: 'https://sproutvideo.com/oembed.json?url=' + 'http://sproutvideo.com/videos/' + video_id,
                crossDomain: true,
                success: function(data, textStatus, jqXHR) {
                    jQuery('div[data-slide-id="' + this.slide_id + '"] .magic-video-container').html(data.html)
                    var $iframe = jQuery('div[data-slide-id="' + this.slide_id + '"] .magic-video-container').find('iframe');
                    var $s = 'autoPlay=true&volume=0&loop=true&background=true';
                    $iframe.attr('data-video-options', $s);
                    if ($iframe.closest('div').is(':visible') && $s != '') {
                        $iframe.attr('src', $iframe.attr('src') + '?' + $s);
                    }
                    jQuery('a[data-slide-id="' + this.slide_id + '"] img').attr('src', data.thumbnail_url).css('max-width', '100px').closest('a').show();
                },
            });
        } else if (video_type == 'sproutvideo_embed') {
            jQuery(this).html('<div class="magic-video-container"><iframe src="' + $videoURL + '?autoPlay=true&volume=0&loop=true&background=true" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>');
            jQuery('a[data-slide-id="' + jQuery(this).attr('data-slide-id') + '"] img').closest('a').show();
        } else {
            jQuery('div[data-slide-id="' + jQuery(this).attr('data-slide-id') + '"],a[data-slide-id="' + jQuery(this).attr('data-slide-id') + '"]').remove();
        }
    })
}
function mtHighlightActiveSelector() {
    if (typeof jQuery == 'undefined') {
        return;
    }
    jQuery('.MagicToolboxContainer .MagicToolboxSelectorsContainer a').removeClass('active-magic-selector');
    jQuery('.MagicToolboxContainer .MagicToolboxSelectorsContainer a.mz-thumb-selected').addClass('active-magic-selector');
    var $s_item = jQuery('.active-magic-selector').closest('.mcs-item');
    if ($s_item.length) {
        MagicScroll.jump('msc-selectors-container', $s_item.data('item'));
    }
   //
      
}
function mtGetMaxSizes() {
    var $maxWidth = $maxHeight = 1;
    jQuery('.MagicToolboxSelectorsContainer a > img').each(function() {
        var img = jQuery(this);
        if (img.is(':visible')) {
            $maxHeight = Math.max($maxHeight, img.height());
            $maxWidth = Math.max($maxWidth, img.width());
        }
    });
    return { 'width': $maxWidth, 'height': $maxHeight };
}
function SirvSKUTransform($sku) {
    if (typeof SirvSpinsPathTransform != 'undefined' && SirvSpinsPathTransform != '') {
        var re = new RegExp('^' + SirvSpinsPathTransform + '$', 'gmsi');
        return $sku.replace(re, '$1');
    }
    return $sku;
}
function mtInitSirv() {
    if (typeof(SirvID) == 'undefined' || SirvID == '') {
        //initMagicScroll();
        return;
    }
    SirvProductSKU = SirvProductSKU.replace(/\//gmi,'-')
    var spinURL = 'https://' + SirvID + '.sirv.com/' +
        SirvSpinsPath.replace(/{product\-id}/g, SirvProductID)
        .replace(/{product\-sku}/g, SirvProductSKU)
        .replace(/{vendor}/g, SirvProductVendor)
        .replace(/{product\-name}/g, SirvProductName);
    if (typeof SirvSpinOverrides != 'undefined' && typeof SirvSpinOverrides[SirvProductID + '-'] != 'undefined' && SirvSpinOverrides[SirvProductID + '-'] != '') {
        spinURL = 'https://' + SirvID + '.sirv.com' + SirvSpinOverrides[SirvProductID + '-'];
    }
    if (typeof SirvCache != 'undefined' && typeof SirvCache[spinURL.replace('https://' + SirvID + '.sirv.com/', '')] != 'undefined') {
        mtInitSirvIcon(spinURL);
    } else {
        if (SirvUseCache == 'Yes') {
            initMagicScroll();
        } else {
            jQuery.ajax({
                url: spinURL,
                type: 'HEAD',
                cache: true,
                timeout: 4000,
                error: function(jqXHR, textStatus, errorThrown) {
                    initMagicScroll();
                },
                success: function(data, textStatus, jqXHR) {
                    mtInitSirvIcon(spinURL);
                },
            });
        }
    }
    if (Object.keys(SirvVariants).length > 0) {
        for (var i in SirvVariants) {
            if (SirvVariantsSKU[i].sku == null) {
                SirvVariantsSKU[i].sku = '';
            }
            SirvVariantsSKU[i].sku = SirvVariantsSKU[i].sku.replace(/\//gmi,'-')
            var $sku = SirvSKUTransform(SirvVariantsSKU[i].sku);
            var v_spinURL = 'https://' + SirvID + '.sirv.com/' +
                ( (typeof SirvSpinsPath_v != 'undefined' && SirvSpinsPath_v != '') ? SirvSpinsPath_v : SirvSpinsPath )
                .replace(/{product\-id}/g, i)
                .replace(/{product\-sku}/g, (typeof SirvVariantsSKU[i].sku != 'undefined' && SirvVariantsSKU[i].sku != '' && SirvVariantsSKU[i].sku != null) ? $sku.replace('/', '') : i)
                .replace(/{vendor}/g, SirvProductVendor)
                .replace(/{product\-name}/g, SirvProductName)
              ;
            for(var $i = 1; $i <= 3; $i++) {
              v_spinURL = v_spinURL.replace( new RegExp('{option' + $i + '}', 'gi'), SirvVariantsSKU[i]['option' + $i] )
              if (typeof mt_product.options[$i-1] != 'undefined') {
                v_spinURL = v_spinURL.replace( new RegExp('{' + mt_product.options[$i-1] + '}', 'gi'), SirvVariantsSKU[i]['option' + $i] )
              }                
            }
          
            if (typeof SirvSpinOverrides != 'undefined' && typeof SirvSpinOverrides[SirvProductID + '-' + i] != 'undefined' && SirvSpinOverrides[SirvProductID + '-' + i] != '') {
                v_spinURL = 'https://' + SirvID + '.sirv.com' + SirvSpinOverrides[SirvProductID + '-' + i];
            }
            if (typeof SirvCache != 'undefined' && typeof SirvCache[v_spinURL.replace('https://' + SirvID + '.sirv.com/', '')] != 'undefined') {
                SirvVariants[i] = v_spinURL.replace(/\?callback.*/gm, '');
                if (i == currentVariantID) {
                    SirvSetActiveItem(SirvVariants[currentVariantID])
                    if (SirvSpinPosition == 'first') {
                        mtShowSirvVariant(currentVariantID)
                    } else {
                        mtInitSirvIcon(SirvVariants[i]);
                        var $h = (SirvMaxHeight > 0) ? '?h=' + SirvMaxHeight : '';
                        //jQuery('.Sirv div').attr('data-src', SirvVariants[i] + $h);
                    }
                    currentVariantID = 0;
                }
            } else {
                if (SirvUseCache == 'Yes') {
                    SirvVariants[i] = false;
                } else {
                    jQuery.ajax({
                        url: v_spinURL,
                        type: 'HEAD',
                        'cache': 'false',
                        timeout: 4000,
                        spinID: i,
                        error: function() { SirvVariants[this.spinID] = false; },
                        success: function(data) {
                            SirvVariants[this.spinID] = this.url.replace(/\?callback.*/gm, '');
                            if (this.spinID == currentVariantID) {
                                SirvSetActiveItem(SirvVariants[currentVariantID])
                                if (SirvSpinPosition == 'first') {
                                    mtShowSirvVariant(currentVariantID)
                                } else {
                                    mtInitSirvIcon(SirvVariants[this.spinID]);
                                    var $h = (SirvMaxHeight > 0) ? '?h=' + SirvMaxHeight : '';
                                    //jQuery('.Sirv div').attr('data-src', SirvVariants[this.spinID] + $h);
                                }
                                currentVariantID = 0;
                            }
                        }
                    });
                }
            }
        }
    }
}
function initMagicScroll() {
    if (jQuery('#msc-selectors-container').length) {
        MagicScroll.start();
    }
}
function mtInitArrows() {
    jQuery('.MagicToolboxSlides .MagicToolboxSlides-arrow').on('click', function(e) {
        var $selectorsContainer = jQuery(this).closest('.MagicToolboxContainer').find('.MagicToolboxSelectorsContainer'),
            $currentSelector = $selectorsContainer.find('a.active-magic-selector'),
            $newSelector = false,
            $useScroll = jQuery('.MagicScroll').length,
            $forward = jQuery(this).hasClass('magic-next'),
            $mscItem, $mscCurItemId, $mscNewItemId;
        if ($useScroll) {
            $mscItem = $currentSelector.parent();
            $mscCurItemId = $mscItem.attr('data-item');
            $mscItem = $forward ? $mscItem.next() : $mscItem.prev();
            if (!$mscItem.length) {
                $mscItem = $selectorsContainer.find('div[data-item=' + $mscCurItemId + ']');
                $mscItem = $forward ? $mscItem.first().next() : $mscItem.last().prev();
                if (!$mscItem.length) {
                    //NOTE: carousel, cover-flow
                    $mscItem = $forward ? $selectorsContainer.find('.mcs-item:first') : $selectorsContainer.find('.mcs-item:last');
                    if (!$mscItem.length) {
                        e.preventDefault();
                        return;
                    }
                }
            }
            $newSelector = $mscItem.find('a');
            $mscNewItemId = $mscItem.attr('data-item');
            $mscNewItemId = parseInt($mscNewItemId, 10);
            MagicScroll.jump('msc-selectors-container', $mscNewItemId);
        } else {
            $newSelector = $forward ? $currentSelector.next('a') : $currentSelector.prev('a');
            if (!$newSelector.length) {
                $newSelector = $forward ? $selectorsContainer.find('a:first') : $selectorsContainer.find('a:last');
            }
        }
        if ($newSelector.length) {
            $newSelector.trigger('click');
            if ($newSelector.hasClass('mz-thumb')) {
                $lockMZUpdate = true;
                MagicZoom.switchTo(jQuery(this).closest('.MagicToolboxContainer').find('a.MagicZoomPlus').attr('id'), $newSelector[0]);
            }
        }
        e.preventDefault();
    });
}
function SirvSetActiveItem(spinURL) {
  spinURL = spinURL.replace(/[^a-zA-Z0-9]/gmi,'');
    var $instance = Sirv.viewer.getInstance('#sirv-spin');
    if ($instance && $instance.isReady() && $instance.items() != null && $instance.items().length) {
        for (var $i in $instance.items()) {
            $instance.disableItem($i * 1);
        }
        $instance.enableItem(spinURL);
    } else {
        jQuery('#sirv-spin [data-id]').attr('data-disabled', 'true');
        jQuery('[data-id="' + spinURL + '"]').removeAttr('data-disabled');
    }
    //Sirv.start();
}
function mtInitSirvIcon(spinURL) {
    if (jQuery('a[data-slide-id="spin"]').length) {
        return;
    }
    var $iconClass = '';
    if (SirvIconURL == 'gif-overlay' || SirvIconURL == 'giftwitch-overlay') {
        $iconClass = 'spin-overlay-icon';
    }
    if (SirvIconURL == 'gif' || SirvIconURL == 'gif-overlay') {
        SirvIconURL = spinURL + '?image'
    }
    if (SirvIconURL == 'giftwitch' || SirvIconURL == 'giftwitch-overlay') {
        SirvIconURL = spinURL + '?image.rules=R30L60R30&image.speed=1000&image.pause=3000'
    }
    $instance = Sirv.viewer.getInstance('#sirv-spin');
    SirvSetActiveItem(spinURL);
    jQuery('.MagicToolboxContainer').removeClass('no-thumbnails');
    jQuery('.MagicToolboxSelectorsContainer').show();
    jQuery('.MagicToolboxSlides .MagicToolboxSlides-arrow').show();
    var sizes = mtGetMaxSizes();
    var iconHTML = ' <a class="' + $iconClass + '" data-slide-id="spin" href="#"><img alt="360 view" id="SirvIcon" style="display:none;" src="' + SirvIconURL + '"/></a>';
    if (jQuery('.MagicToolboxSelectorsContainer a').length == 0) {
        jQuery('.MagicToolboxSlides .MagicToolboxSlides-arrow').hide();
        jQuery('.MagicToolboxSelectorsContainer').append(iconHTML);
    } else if (SirvSpinPosition == 'last') {
        jQuery('.MagicToolboxSelectorsContainer a:last').after(iconHTML);
    } else if (SirvSpinPosition == 'second') {
        jQuery('.MagicToolboxSelectorsContainer a:first').after(iconHTML);
    } else {
        jQuery('.MagicToolboxSelectorsContainer a:first').before(iconHTML);
    }
    if (jQuery('.MagicToolboxContainer').hasClass('layout-bottom')) {
        jQuery('#SirvIcon').css('height', sizes.height + 'px').show();
    } else {
        jQuery('#SirvIcon').css('width', sizes.width + 'px').show();
    }
    mtInitSelectors('.MagicToolboxSelectorsContainer a[data-slide-id="spin"]');
    if (SirvSpinPosition == 'first') {
        if (SirvVariants[currentVariantID]) {
            mtShowSirvVariant(currentVariantID);
            currentVariantID = 0;
        } else {
            jQuery('.MagicToolboxSelectorsContainer a[data-slide-id="spin"]').trigger('click');
        }
    }
    if (jQuery('.MagicToolboxSelectorsContainer a').length == 0) {
        jQuery('.MagicToolboxContainer').addClass('no-thumbnails');
        jQuery('.MagicToolboxSlides .MagicToolboxSlides-arrow, .MagicToolboxSelectorsContainer').hide();
        jQuery('div[data-slide-id="zoom"]').removeClass('active-magic-slide');
        jQuery('div[data-slide-id="spin"]').addClass('active-magic-slide');
        Sirv.start();
    }
    initMagicScroll();
}
function mtShowSirvVariant(variant_id) {
  
    if (jQuery('#SirvIcon').length == 0) {
        var $useScroll = jQuery('#msc-selectors-container').length;
        if ($useScroll) {
            MagicScroll.stop();
        }
        mtInitSirvIcon(SirvVariants[variant_id]);
    }
    var $h = (SirvMaxHeight > 0) ? '?h=' + SirvMaxHeight : '';
    var $instance = Sirv.viewer.getInstance('#sirv-spin'),
        spinURL = SirvVariants[variant_id];
    SirvSetActiveItem(SirvVariants[variant_id])
    if (SirvIconURL_ == 'gif' || SirvIconURL_ == 'gif-overlay') {
        SirvIconURL = spinURL + '?image'
    }
    if (SirvIconURL_ == 'giftwitch' || SirvIconURL_ == 'giftwitch-overlay') {
        SirvIconURL = spinURL + '?image.rules=R30L60R30&image.speed=1000&image.pause=3000'
    }
    jQuery('a[data-slide-id="spin"] img').attr('src', SirvIconURL)
    if (SirvSpinPosition == 'first') {
        jQuery('a[data-slide-id="spin"]').trigger('click');
    } else {
        jQuery('a.mz-thumb-selected').trigger('click')
    }
}
function mtSwitchImage(largeImage, smallImage) {
    var activeSlide = jQuery('.MagicToolboxContainer .active-magic-slide');
    if (activeSlide.attr('data-slide-id') == 'spin') {
        activeSlide.removeClass('active-magic-slide');
        jQuery('.MagicToolboxContainer .MagicToolboxSlide[data-slide-id="zoom"]').addClass('active-magic-slide');
    }
    if (jQuery('.mz-lens').length == 0) {
        mtHighlightActiveSelector();
        jQuery('a.MagicZoomPlus').attr('href', largeImage)
        jQuery('a.MagicZoomPlus img').first().attr('src', smallImage);
    } else {
        MagicZoom.update(jQuery('a.MagicZoomPlus').attr('id'), largeImage, smallImage);
    }
}
window['MagicjQueryTries'] = 0;
function mtOnDomReady(fnc) {
    if (typeof(jQuery) == 'undefined') {
        window['MagicjQueryTries']++;
        if (window['MagicjQueryTries'] == 10) {
            var mt_jq = document.createElement('script');
            mt_jq.type = 'text/javascript';
            mt_jq.async = false;
            mt_jq.src = 'https://code.jquery.com/jquery-2.2.4.min.js';
            document.getElementsByTagName('script')[0].parentNode.appendChild(mt_jq);
        }
        setTimeout(function() {
            mtOnDomReady(fnc);
        }, 250);
        return;
    }
    jQuery(document).ready(fnc);
}
function mtGetParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
function mtGetVariantId() {
    // Try to get variant from URL
    var variantId = mtGetParameterByName('variant');
    // If not get variants on product object
    if (!variantId && typeof mt_product != 'undefined' && mt_product.variants && mt_product.variants.length > 0) {
        for (var i = 0; i < mt_product.variants.length; i++) {
            if (mt_product.variants[i].available) {
                variantId = mt_product.variants[i].id;
                break;
            }
        }
    }
    return variantId;
}
function updateMZPGallery($id) {
    var $s = jQuery('a[data-variants*="' + $id + '"]');
    if ($s.length) {
        $s.show();
        $s.prevAll().hide();
        var $hide = false;
        $s.nextAll().each(function() {
            if (jQuery(this).attr('data-variants') != ',') {
                $hide = true;
            }
            if ($hide) {
                jQuery(this).hide();
            } else {
                jQuery(this).show();
            }
        })
        jQuery('a[data-slide-id="spin"]').show();
    }
}
function initmzp() {
    if (jQuery('#admin_bar_iframe').length) {
        jQuery(document.body).append(
            '<style type="text/css">.mz-zoom-window { margin-top: -' + jQuery('#admin_bar_iframe').height() + 'px; </style>'
        );
    }
    window['SirvIconURL_'] = (typeof SirvIconURL != 'undefined')?SirvIconURL:'';
    mtInitVideoSelectors('.MagicToolboxSelectorsContainer a');
    mtInitSelectors('.MagicToolboxSelectorsContainer a');
    var $firstVideoSelector = jQuery('[data-slide-num="0"][data-video-url]');
    if ($firstVideoSelector.length) {
        jQuery('a[data-slide-id="' + $firstVideoSelector.attr('data-slide-id') + '"]').trigger('click');
        $firstImageIsVideo = true;
    }
    mtInitSirv();
    mtInitArrows();
}
mtOnDomReady(function() {
    initmzp();
});